import { createReducer } from '@reduxjs/toolkit'

import { dspAdvertisersTableColumnsConfig } from 'configuration/tables/dspCampaignFactsTable'
import { BRANDS, DATES, DSP_ADVERTISERS, DSP_COUNTRIES } from 'const/filters'
import { FILTER_SETTINGS, FILTERS } from 'const/reducerKeys'
import { serializeColumns } from 'helpers/tables'
import { defaultTab, getDefaultTable } from 'reducers/ui/defaults'

const initialState = {
    ...defaultTab,
    [FILTERS]: {
        [BRANDS]: [],
        [DSP_ADVERTISERS]: [],
        [DSP_COUNTRIES]: [],
    },
    [FILTER_SETTINGS]: {
        anchored: [DATES],
        order: [BRANDS, DSP_ADVERTISERS, DSP_COUNTRIES],
        displayState: {
            [BRANDS]: true,
            [DSP_ADVERTISERS]: true,
            [DSP_COUNTRIES]: true,
        },
    },
    table: getDefaultTable(serializeColumns(dspAdvertisersTableColumnsConfig), {
        sorter: {
            field: 'total_cost__sum',
            order: 'descend',
        },
    }),
}

export default createReducer(initialState, () => {})
